// extracted by mini-css-extract-plugin
module.exports = {"openinapp":"P_1Oo","show-sticky":"_PA8f"};